<img src="assets/images/no-results.svg" [alt]="'dtmUi.noResults.imageAltText' | transloco" />
<div class="title">{{ (title$ | ngrxPush) ?? ("dtmUi.noResults.message" | transloco) }}</div>
<p *ngIf="areFiltersApplied$ | ngrxPush">{{ "dtmUi.noResults.hintText" | transloco }}</p>
